<template>
  <div class="alert alert-danger p-2">
    <ul role="alert">
      <li class="justified" v-for="err in errors" :key="err">{{ err }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
    },
  },
};
</script>
